'use client'

import { defaultState } from './defaultState'
import type { ListingSearchContextValue } from './types'

const defaultContextValue: ListingSearchContextValue = {
  state: defaultState,
  data: null,
  isLoading: true,
  dispatch: () => null,
  setPage: () => null,
  setSavedSearch: () => null,
  setSort: () => null,
  setPageSize: () => null,
  setView: () => null,
  setSortFrozen: () => null,
  recordBidPlacedWhileFrozen: () => null,
  getActiveFilterCount: () => 0,
  updateFilters: () => null,
  resetFilters: () => null,
  updateSearchData: () => null,
  currentImpressionId: null,
  similarSearch: {
    enabled: false,
    data: undefined,
    isFetching: false,
  },
  myBidsFilter: {
    isLoading: false,
    isError: false,
  },
  personalizationEligibility: 'pending',
}

export default defaultContextValue
